import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import OAuthCallback from './OAuthCallback';

const useCognitoByocCallback = () => {
  const location = useLocation();
  const { handleOAuthCallback } = useAuth();
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const errorParam = params.get('error');
    const errorDescription = params.get('error_description');
    const state = params.get('state');

    if (errorParam) {
      const message = errorDescription || `SSO authentication failed: ${errorParam}`;
      setError(message);
      setTimeout(() => window.location.replace('/'), 4000);
      return;
    }

    if (!code) {
      setError('No authorization code received from SSO provider');
      setTimeout(() => window.location.replace('/'), 4000);
      return;
    }

    handleOAuthCallback(code, 'cognito', { state });
  }, [location, handleOAuthCallback]);

  return { error };
};

const CognitoByocCallback = () => {
  const { error } = useCognitoByocCallback();
  // Use provider="oauth" so OAuthCallback's internal hook does a noop
  // (no stored oauth_auth_state in sessionStorage). We drive everything via externalError.
  return <OAuthCallback provider="cognito" externalError={error ?? null} skipProcessing={true} />;
};

export default CognitoByocCallback;
